// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'organization-position.page.title': 'Organization Positions',
    'organization-position.page.archive.title': 'Archived Positions',
    'organization-position.page.search_results': 'Search Results',
    'organization-position.page.create.title': 'Create New Position',
    'organization-position.page.search.title': 'Find Positions',
    'organization-position.page.edit.title': 'Edit Position',
    'organization-position.page.view.title': 'View Position',
    'organization-position.page.all': 'All',

    'organization-position.button.cancel': 'Cancel',
    'organization-position.button.select': 'Select',
    'organization-position.button.find': 'Find Positions',
    'organization-position.button.search': 'Apply',
    'organization-position.button.create': 'Save Position',
    'organization-position.button.new': 'New Position',
    'organization-position.button.save': 'Save Changes',
    'organization-position.button.archive': 'Move to Archive',
    'organization-position.button.delete': 'Permanently Delete',
    'organization-position.button.edit': 'Edit',
    'organization-position.button.restore': 'Restore',
    'organization-position.button.reset': 'Reset',

    'organization-position.placeholder.search': 'Search organization positions',

    'organization-position.link.create_first_organization_position': 'Click here to create your first organization position',
    'organization-position.link.organization_positions': ' Return to Organization Positions',
    'organization-position.link.archive': 'Archived Positions',
    'organization-position.link.retry': 'Click here to retry',

    'organization-position.checkbox.all': 'Check All',
    'organization-position.checkbox.actions_label': 'with selected',

    'organization-position.label.organization_position_name': 'Position Name',

    'organization-position.label.application_code': 'Application Code',

    'organization-position.label.application_sub_code': 'Application Sub Code',

    'organization-position.label.from__created_at': 'From created at',
    'organization-position.label.to__created_at': 'To created at',
    'organization-position.label.created_at': 'Created At',

    'organization-position.label.from__updated_at': 'From updated at',
    'organization-position.label.to__updated_at': 'To updated at',
    'organization-position.label.updated_at': 'Updated At',

    'organization-position.label.from__deleted_at': 'From deleted at',
    'organization-position.label.to__deleted_at': 'To deleted at',
    'organization-position.label.deleted_at': 'Deleted At',

    'organization-position.label.status': 'Status',

    'organization-position.sort.field_label': 'Field',
    'organization-position.sort.direction_label': 'Direction',
    'organization-position.sort.direction_ascending': 'Ascending',
    'organization-position.sort.direction_descending': 'Descending',

    'organization-position.modal.title.organization_position_archive': 'Archive Position',
    'organization-position.modal.title.organization_position_delete_permanently': 'Delete Position',
    'organization-position.modal.title.organization_position_restore': 'Restore Position',

    'organization-position.modal.message.organization_position_archive': 'Are you sure that you want to move this organization position to the archive? | Are you sure that you want to move these organization positions to the archive?',
    'organization-position.modal.message.organization_position_delete_permanently':
        'Are you sure that you want to permanently delete this organization position? This action cannot be undone. | Are you sure that you want to permanently delete these organization positions? This action cannot be undone.',
    'organization-position.modal.message.organization_position_restore': 'Are you sure that you want to restore this organization position? | Are you sure that you want to restore these organization positions?',

    'organization-position.success.message.organization_position_created': 'Your organization position has been created',
    'organization-position.success.message.organization_position_updated': 'Your organization position has been updated',
    'organization-position.success.message.organization_position_restored': 'Your organization position has been restored | All selected organization positions were restored',
    'organization-position.success.message.organization_position_deleted': 'Your organization position has been permanently deleted | All selected organization positions were permanently deleted',
    'organization-position.success.message.archived_organization_positions': 'Your organization position was moved to the archive | All selected organization positions were moved to the archive',

    'organization-position.error.message.archived_organization_positions': 'This organization position was already moved to the archive | These organization positions were already moved to the archive',
    'organization-position.error.message.archive_not_allowed_organization_positions': 'This organization position is already archived | These organization positions are already archived',
    'organization-position.error.message.restore_not_allowed_organization_positions': 'This organization position is not in the archive and cannot be restored | These organization positions are not in the archive and cannot be restored',
    'organization-position.error.message.organization_position_deleted': 'This organization position was already permanently deleted | These organization positions were already permanently deleted',
    'organization-position.error.message.organization_position_restored': 'This organization position was already restored | These organization positions were already restored',
    'organization-position.error.message.error_loading_page': 'Sorry, there was an error loading organization position.| Sorry, there was an error loading organization positions.',

    'organization-position.message.search.no_archived_organization_positions': "You don't have any archived organization positions.",
};
